export default {
    methods: {
        toDate(timestamp){
            if (!timestamp)
                return ''

            var date = new Date(timestamp)
            var day = "0" + date.getDate()
            var month = "0" + (date.getMonth() + 1)
            var year = date.getFullYear()

            return year + '-' + month.substr(-2) + '-' + day.substr(-2)
        },

        toTime(timestamp){
            if (!timestamp)
                return ''

            var date = new Date(timestamp)
            var hours = "0" + date.getHours()
            var minutes = "0" + date.getMinutes()
            var seconds = "0" + date.getSeconds()

            return hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)
        },

        toDatetime(timestamp){
            if (!timestamp)
                return ''

            return this.toDate(timestamp) + ' ' + this.toTime(timestamp)
        }
    }
}